import React, { useEffect, useState } from 'react'

export default function useDarkTheme() {
    const [darktheme, setTheme] = useState({
        secondaryColor: '#1C1816',
        backgroundColor: '#000',
        fontColor: "#fff",
        headerColor: "#000",
        borderColor: "#000",
        lightTheme: "#1c1816",
        borderTheme: "#1c1816",
        footerColor: "#fff",
        footerTheme: "#1c1816",
        themeBtn : "#000",
        lightthemeBtn : "#e4002b",
      });
    
      useEffect(() => {
        const savedTheme = localStorage.getItem("color-theme");
    
        if (savedTheme) {
          setTheme(JSON.parse(savedTheme));
        }
      }, []);
    
      function toggleDarkTheme() {
        const newTheme = {
            secondaryColor: '#1C1816',
            backgroundColor: '#000',
            fontColor: "#fff",
            headerColor: "#000",
            borderColor: "#000",
            lightTheme: "#1c1816",
            borderTheme: "#1c1816",
            footerColor: "#fff",
            footerTheme: "#1c1816",
            themeBtn : "#000",
            lightthemeBtn : "#e4002b",
        };
    
        setTheme(newTheme);
        localStorage.setItem("color-theme", JSON.stringify(newTheme));
      }
    
      useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty("--black", darktheme.backgroundColor);
        root.style.setProperty("--second-color", darktheme.secondaryColor);
        root.style.setProperty("--white", darktheme.fontColor);
        root.style.setProperty("--header-color", darktheme.headerColor);
        root.style.setProperty("--border-color", darktheme.borderColor);
        root.style.setProperty("--light-theme", darktheme.lightTheme);
        root.style.setProperty("--border-theme", darktheme.borderTheme);
        root.style.setProperty("--footer-theme", darktheme.footerTheme);
        root.style.setProperty("--footer-color", darktheme.footerColor);
        root.style.setProperty("--dark-mode", darktheme.themeBtn);
        root.style.setProperty("--light-mode", darktheme.lightthemeBtn);
        
      }, [darktheme]);


    //   ===Black Theme===

 
    return { darktheme, toggleDarkTheme }
}
